import React, { SVGProps } from 'react'
const SvgShowHover = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      d="M21.58 12.525a.75.75 0 0 1 0 .95c-6.3 7.7-12.86 7.7-19.16 0a.75.75 0 0 1 0-.95c6.3-7.7 12.86-7.7 19.16 0ZM12 16.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Zm0-1.5a2.25 2.25 0 1 1 0-4.5 2.25 2.25 0 0 1 0 4.5Z"
    />
  </svg>
)
export default SvgShowHover
